import ProgressBar from "./ProgressBar";
import Text from "./Text";
import styles from "./UploadProgress.module.css";

interface UploadProgressProps {
  /** Pourcentage du corps de la requête envoyé (0-100). */
  percent: number;
  /** Vrai tant que la réponse du serveur n'est pas arrivée. */
  uploading: boolean;
  /** Libellé de la phase serveur, une fois le corps entièrement envoyé. */
  processingText?: string;
}

/**
 * Indicateur d'envoi affiché jusqu'à la réponse du serveur, et pas seulement
 * jusqu'à la fin de l'envoi du corps : le serveur travaille encore après 100 %
 * (redimensionnement des photos, vignettes) et le fichier n'est rattaché au
 * formulaire qu'à la réponse.
 */
export default function UploadProgress({
  percent,
  uploading,
  processingText = "Traitement des fichiers en cours…",
}: UploadProgressProps) {
  if (!uploading) return null;

  const sent = percent >= 100;

  return (
    <div className={styles.container} role="status">
      <Text variant="deci">
        {sent ? processingText : `Envoi des fichiers en cours (${percent} %)`}
      </Text>
      <ProgressBar
        value={sent ? 100 : percent}
        label="Progression de l'envoi"
        className={sent ? styles.processing : undefined}
      />
    </div>
  );
}
